import { Outlet } from 'react-router-dom';

const ChooseTemplateRootView = () => {
  return <Outlet />;
};

export default ChooseTemplateRootView;
